import * as yup from "yup";

const model = {
  id:0,
  bankName: "",
  accountNumber: "",
  ifscCode: "",
  branch: "",
  shortCode: "",
  swiftCode: "",
  address: "",
  remarks: "",
  status: true,
};

const validationModel = yup.object().shape({
  id: yup.number().required("Bank id is required!"),
  bankName: yup.string().required("Bank Name is required!"),
  accountNumber: yup.string().required("A/c Number is required!"),
  ifscCode: yup.string().required("IFSC Code is required!"),
  branch: yup.string().required("Branch Name is required!"),
  shortCode: yup.string().required("Bank Short Code is required!"),
  swiftCode: yup.string(),
  address: yup.string().required("Address is required!"),
  remarks: yup.string(),
  status:yup.boolean().nullable()
});
export { model,validationModel };
